function UserAvatar ({ user, className }) {
  console.log(user.profile);
  return (
    <img src={user.profile.image_url || "/assets/images/avatars/avatar.jpg"} alt={user.full_name || user.username} className={className} />
  );
}

export default UserAvatar;
